
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[site]/category/[id]",
      function () {
        return require("private-next-pages/_sites/[site]/category/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[site]/category/[id]"])
      });
    }
  